import { cn } from '@/internationalization/cn'
import { useT } from '@/internationalization/i18n'
import { isUnattributed, speakerColorVar } from '@/internationalization/speaker-color'

/**
 * A speaker's name in their transcript colour.
 *
 * An unattributed voice renders grey with an explicit label, never a coloured
 * name — colour reads as identification, and there is nothing to identify.
 */
export function SpeakerChip({
  name,
  label,
  className,
}: {
  name: string | null
  /** Acoustic label to fall back on, e.g. 'spk_2'. */
  label?: string
  className?: string
}) {
  const t = useT()
  const unknown = isUnattributed(name)
  const token = speakerColorVar(name)
  const display = unknown
    ? label
      ? t('speaker.unnamedWithLabel', { label })
      : t('speaker.unnamed')
    : name

  return (
    <span
      className={cn('inline-flex items-center gap-1.5 text-sm font-semibold', className)}
      style={{ color: `hsl(var(${token}))` }}
    >
      <span aria-hidden className="h-2 w-2 rounded-full" style={{ backgroundColor: `hsl(var(${token}))` }} />
      <span className={cn(unknown && 'italic font-medium')}>{display}</span>
    </span>
  )
}
